// ** Third Party Components
import { Sun, Moon, BookOpen } from 'react-feather'
import mixpanel from 'mixpanel-browser'

// ** Reactstrap Imports
import { Button, Input, Label, NavItem, NavLink } from 'reactstrap'
import { useEffect } from 'react'
import {  useSelector } from 'react-redux'
import {useSkin} from "../../../../utility/hooks/useSkin"

// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
import UserDropdown from './UserDropdown'
import NotificationDropdown from './NotificationDropdown'
import { trans } from '../../../../configs/i18n'

const NavbarUser = () => {
    // ** Props
    const { skin, setSkin } = useSkin()
    const userData = useSelector(state => state.auth?.user)

    useEffect(() => {
        mixpanel.init('a2dfc9431876187273542e99f6f60721', { debug: false })

        if (userData?.user) {
            mixpanel.identify(userData?.user?.id)
            mixpanel.people.set({
                $id: userData?.user?.id,
                $name: userData?.user?.username,
                $email: userData?.user?.email,
                $avatar: userData?.user?.avatar
            })
        }

        const HW_config = {
            selector: '.headway', // CSS selector where to inject the badge
            account: 'JVpYRx',
            'positio.x': '0',
            'position.y': '0',
            translations: {
                title: trans('headway.title'),
                footer: trans('headway.footer') + '👉'
            }
        }

        window.Headway?.init(HW_config)
    }, [])

    // ** Function to toggle Theme (Light/Dark)
    const ThemeToggler = () => {
        if (skin === 'dark') {
            return <Sun className="ficon" onClick={() => setSkin('light')} />
        } else {
            return <Moon className="ficon" onClick={() => setSkin('dark')} />
        }
    }
    useEffect(() => {}, [])

    return (
        <ul className="nav navbar-nav align-items-center ms-auto">
            <IntlDropdown />
            {/*<NavItem className="d-none d-lg-block">*/}
            {/*    <NavLink className="nav-link-style">*/}
          <ThemeToggler />
            {/*    </NavLink>*/}
            {/*</NavItem>*/}
            {/*<NavbarSearch />*/}
            {/*<CartDropdown />*/}
            {userData?.user && <NotificationDropdown />}
            {userData?.user && <UserDropdown />}
            <Button size="sm" className="headway" color="link" outline>
                <BookOpen />
            </Button>
        </ul>
    )
}
export default NavbarUser
